import styled from "styled-components";

const BreakPc = styled.br`
  @media screen and (max-width: 960px) {
    display: none;
  }
`;
export default BreakPc;
